/** Copy for the shared table pagination (kept out of the component per the repo rule). */
export const paginationStrings = {
  rowsPerPage: "Rows per page",
  /** "{range} of {total}"; range and total render emphasised. */
  summary: "{range} of {total}",
  range: "{first}–{last}",
  previousPage: "Previous page",
  nextPage: "Next page",
  goTo: "Go to",
  goToPage: "Go to page",
  pagePlaceholder: "Page",
  go: "Go",
  pageAria: "Page {page}",
  currentPageAria: "Page {page}, current page",
  navAria: "Pagination",
};
